var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _ellipse2, _path8, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcVacateHouse2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 135,
    viewBox: "0 0 202 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.609 79.2099L160.98 47.4531L139.5 71.9027V128.75H177.609V79.2099Z",
    fill: "#BFD9F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6086 77.9297H142.041V128.741H83.6086V77.9297Z",
    fill: "#E8F2FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.737 47.4531H103.522L83.6086 77.9396H142.041L160.737 47.4531Z",
    fill: "#8CAFD9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.9916,
    cy: 72.1791,
    rx: 13.9916,
    ry: 13.9916,
    fill: "#FFDCD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7061 93.6023L49.7481 83.3418L37.3111 73.7031L34.2019 93.6023H45.7061Z",
    fill: "#FFDCD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3269 68.4588L63.7387 66.5933C61.2513 58.8202 50.9908 55.4 42.9068 60.6857C36.4395 64.9143 36.481 72.3972 37.3101 75.6101L46.3269 68.4588Z",
    fill: "#2B374E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2501 100.047C12.2868 93.2892 18.5113 88.6641 25.5696 88.6641H52.4673C63.1935 88.6641 70.8818 99.0109 67.7867 109.281L63.7499 122.676C61.7132 129.434 55.4887 134.059 48.4304 134.059H21.5327C10.8065 134.059 3.11824 123.712 6.21329 113.442L10.2501 100.047Z",
    fill: "#2B374E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9605 104.805C51.5877 104.805 47.0109 108.989 45.3941 111.081L46.8865 116.62H53.6025C55.0949 116.62 57.3336 115.881 58.826 114.774C60.02 113.888 61.3134 111.205 61.8109 109.974C67.0344 109.974 71.5117 109.605 71.5117 107.758C71.5117 105.912 63.6764 104.805 56.9605 104.805Z",
    fill: "#FFDCD5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.1367,
    cy: 22.9375,
    rx: 22,
    ry: 22,
    fill: "#2B374E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4252 52.9531L42.3644 37.2593L60.486 37.2593L51.4252 52.9531Z",
    fill: "#2B374E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.3289,
    y: 14.8281,
    width: 21.8289,
    height: 2.2,
    transform: "rotate(45 45.3289 14.8281)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.7637,
    y: 15.8828,
    width: 21.8289,
    height: 2.2,
    transform: "rotate(135 60.7637 15.8828)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVacateHouse2);
export default __webpack_public_path__ + "static/media/IcVacateHouse2.5b51f37502104a517a8048684851ebcf.svg";
export { ForwardRef as ReactComponent };